import filterQueryBuilder from 'helpers/filterToQuery'
import { requests, mainApiRoot } from './index'

export const Admin = {
  getUsers: (filters = {}) =>
    requests.get(mainApiRoot, `/admin/users${filterQueryBuilder(filters)}`),
  getDomains: (id, filters = {}) =>
    requests.get(mainApiRoot, `/admin/users/${id}/domains${filterQueryBuilder(filters)}`),
  getImpersonate: id => requests.get(mainApiRoot, `/admin/users/${id}/impersonate`)
}
